<div class="details-list">
  <div class="images">
    @for (product of list; track product; let j = $index) {
      <div class="images">
        @for (item of product?.items; track item; let i = $index) {
          <div>
            @if (i < 1 && j < 4) {
              <div class="img-container">
                <img
                  [defaultImage]="defaultImage"
                  [lazyLoad]="item?.image_url"
                  alt=""
                  />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
